import React, { useState } from 'react';
import {
	Panel,
	Tabs,
	ProgressCircle,
	Pagination,
} from '@bigcommerce/big-design';
import PhotoContestGrid from './components/PhotoContestGrid';
import PhotoContestPanel from './components/PhotoContestPanel';
import { usePhotoContest } from './hooks/usePhotoContest';

export default function PhotoContestPage() {
	const {
		submissions,
		total,
		counts,
		loading,
		status,
		setStatus,
		page,
		setPage,
		limit,
		setLimit,
		updateStatus,
	} = usePhotoContest();

	const [selectedSubmission, setSelectedSubmission] = useState(null);

	const totalCount =
		(counts.pending || 0) +
		(counts.approved || 0) +
		(counts.rejected || 0);

	const tabs = [
		{ id: 'all', title: `All (${totalCount})` },
		{ id: 'pending', title: `Pending (${counts.pending || 0})` },
		{ id: 'approved', title: `Approved (${counts.approved || 0})` },
		{ id: 'rejected', title: `Rejected (${counts.rejected || 0})` },
	];

	const activeTab = status ?? 'all';

	const handleTabClick = (tabId) => {
		setStatus(tabId === 'all' ? null : tabId);
		setPage(1);
	};

	const handleStatusUpdate = async (id, newStatus) => {
		await updateStatus(id, newStatus);
		setSelectedSubmission(null);
	};

	return (
		<Panel header="Photo Contest">
			<Tabs
				activeTab={activeTab}
				items={tabs}
				onTabClick={handleTabClick}
			/>
			{loading ? (
				<ProgressCircle size="large" />
			) : (
				<>
					<PhotoContestGrid
						submissions={submissions}
						onCardClick={setSelectedSubmission}
					/>
					{total > limit && (
						<div style={{ display: 'flex', justifyContent: 'center' }}>
							<Pagination
								currentPage={page}
								totalItems={total}
								itemsPerPage={limit}
								itemsPerPageOptions={[24, 48, 96, 128]}
								onPageChange={setPage}
								onItemsPerPageChange={setLimit}
							/>
						</div>
					)}
				</>
			)}
			<PhotoContestPanel
				submission={selectedSubmission}
				onClose={() => setSelectedSubmission(null)}
				onUpdateStatus={handleStatusUpdate}
			/>
		</Panel>
	);
}
